// This config file centralizes environment variables
// These values are embedded at build time

export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string;

// Validate that the API key exists
if (!GOOGLE_MAPS_API_KEY) {
  console.warn('VITE_GOOGLE_MAPS_API_KEY is not defined in environment variables.');
} 